import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateSchedulePreferences, fetchSchedules, type SchedulePreferencesPayload } from '@/features/accounts/api';
import { type Schedule } from '@/features/accounts/types';

export function useUpdateSchedulePreferences() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ scheduleId, preferences }: { scheduleId: number; preferences: SchedulePreferencesPayload }) => {
      await updateSchedulePreferences(scheduleId, preferences);

      const schedules = await queryClient.fetchQuery({
        queryKey: ['schedules', { bookable: true }],
        queryFn: () => fetchSchedules(true),
        staleTime: 0,
      });
      await queryClient.invalidateQueries({ queryKey: ['schedules', { bookable: false }] });

      return schedules.find((schedule: Schedule) => schedule.id === scheduleId);
    },
  });
}
